import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SCORECARD_DETAILS_API_ACTIONS } from '../../store/actions';

export const scorecardDetailsResolver: ResolveFn<boolean> = (route) => {
  const store = inject(Store);
  const scorecardId = route.params['id'] as string;

  if (scorecardId) {
    store.dispatch(SCORECARD_DETAILS_API_ACTIONS.get({ scorecardId }));
  }

  return true;
};
